import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SystemService } from 'common/services/core-services/system.service';

@Component({
  selector: 'sm-confirm',
  templateUrl: './sm-confirm.component.html',
  styleUrls: ['./sm-confirm.component.scss']
})
export class SmConfirmComponent implements OnInit {
  
    @Input() title: string;
    @Input() message: string;
    @Input() props;
    @Input() form;
    @Output() confirm = new EventEmitter<any>();
    @Output() invalidFields = new EventEmitter<any>();

    constructor(private modalService: NgbModal, private ss: SystemService) {}


    ngOnInit(): void {
    }
    open(content) {
        if (this.form.valid) {
            this.modalService.open(content, {
                backdrop: 'static',
                keyboard: false,
                centered: true,
                size: 'md',
                
               });
        } else {
            let invalidValues = this.getInvalidFieldNames();
            this.invalidFields.emit(invalidValues);
            this.ss.showError(`Please fill the form properly`);
            this.form.markAllAsTouched();
        }
    }

    onBtnClick(event, c): void {
        this.confirm.emit(event);
        c();
    }

    getInvalidFieldNames(): string[] {
        const invalidFieldNames: string[] = [];

        Object.keys(this.form.controls).forEach((controlName: any) => {
            const control = this.form.controls[controlName];
            if (control.invalid) {
                invalidFieldNames.push(controlName);
            }
        });

        return invalidFieldNames;
    }
}
